/* Divine Hindu — puja catalogue (Oct 2026).
 * Powers the puja hub (/pages/pooja-seva) and every puja collection page (template collection.puja).
 * Data: /collections/<handle>?view=puja-data (templates/collection.puja-data.liquid), all pages fetched once.
 * Search, facet filters (booking type, deity, need, festival or day, ritual, state, price), sort, "show more",
 * and the filter state kept in the URL so a filtered list can be shared. Cards show the next group puja date
 * from the shop calendar (shop.metafields.custom.puja_calendar). No cart, checkout or GoKwik code here.
 */
(function () {
  'use strict';
  if (window.DHPuja && window.DHPuja.__catalogue) return;

  var L = {
    type: { group: 'Group puja', personal: 'Personal puja', seva: 'Seva & offerings' },
    deity: { shiv: 'Shiv', devi: 'Devi', ganesh: 'Ganesh', murugan: 'Murugan', ayyappa: 'Ayyappa', hanuman: 'Hanuman', vishnu: 'Vishnu & Krishna', navgraha: 'Navgraha & Shani', bhairav: 'Kaal Bhairav', nag: 'Nag Devta', rivers: 'Ganga & holy rivers', pitru: 'Pitru (ancestors)' },
    need: { health: 'Health & long life', wealth: 'Wealth & prosperity', marriage: 'Marriage & family', career: 'Career & new beginnings', education: 'Education', protection: 'Protection', peace: 'Peace of mind', obstacles: 'Removing obstacles', graha: 'Graha shanti & dosh', ancestors: 'Ancestors' },
    ritual: { abhishek: 'Abhishek', havan: 'Havan & yagya', jaap: 'Jaap & anushthan', path: 'Path & recitation', seva: 'Offerings & seva', archana: 'Archana & special pujas', dosh: 'Dosh nivaran', pitru: 'Pitru rites' },
    occasion: { navratri: 'Navratri', diwali: 'Diwali', mahashivratri: 'Mahashivratri', shravan: 'Shravan (Sawan)', 'ganesh-chaturthi': 'Ganesh Chaturthi', janmashtami: 'Janmashtami', kartik: 'Kartik month', 'hanuman-jayanti': 'Hanuman Jayanti', 'nag-panchami': 'Nag Panchami', 'kaal-bhairav-jayanti': 'Kaal Bhairav Jayanti', 'skanda-sashti': 'Skanda Sashti', 'karthigai-deepam': 'Karthigai Deepam', 'vaikunta-ekadasi': 'Vaikunta Ekadasi', 'arudra-darshan': 'Arudra Darshan', thaipusam: 'Thaipusam', amavasya: 'Amavasya', purnima: 'Purnima', ekadashi: 'Ekadashi', pradosh: 'Pradosh', 'sankashti-chaturthi': 'Sankashti Chaturthi', birthday: 'Birthday', anniversary: 'Wedding anniversary', 'griha-pravesh': 'Griha pravesh', 'new-venture': 'New business', 'death-anniversary': 'Death anniversary (shraddha)' },
    price: { '0-1000': 'Under ₹1,000', '1000-2500': '₹1,000 – ₹2,500', '2500-5000': '₹2,500 – ₹5,000', '5000-10000': '₹5,000 – ₹10,000', '10000-': 'Above ₹10,000' }
  };
  var ENGLISH_L = JSON.parse(JSON.stringify(L));
  var displayNode = document.querySelector('[data-dhc-ui]'), DISPLAY = {};
  try { DISPLAY = displayNode ? JSON.parse(displayNode.textContent || '{}') : {}; } catch (e) {}
  var locale = DISPLAY.locale || document.documentElement.lang || 'en';
  function tr(source, values) {
    var result = DISPLAY.copy && DISPLAY.copy[source] || source;
    Object.keys(values || {}).forEach(function (key) { result = result.split('{' + key + '}').join(String(values[key])); });
    return result;
  }
  function localUrl(url) {
    var root = (DISPLAY.root || '/').replace(/\/$/, ''), value = String(url || '');
    if (root && /^\/(products|collections|pages|blogs)(?:\/|[?#]|$)/.test(value)) return root + value;
    return value;
  }
  Object.keys(L).forEach(function (f) { Object.keys(L[f]).forEach(function (key) { L[f][key] = tr(L[f][key]); }); });
  var FACETS = ['type', 'deity', 'need', 'occasion', 'ritual', 'state', 'price'];
  var FTITLE = { type: 'Booking type', deity: 'Deity', need: 'Need', occasion: 'Festival or day', ritual: 'Ritual', state: 'State', price: 'Price' };
  var FIXED_ORDER = { type: ['group', 'personal', 'seva'], price: ['0-1000', '1000-2500', '2500-5000', '5000-10000', '10000-'] };
  var PAGE = 24;

  /* ---------- helpers ---------- */
  function money(p) { return '₹' + Math.round((Number(p) || 0) / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function titleCase(k) { return String(k || '').split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' '); }
  function label(f, k) { return (L[f] && L[f][k]) || tr(titleCase(k)); }
  function englishLabel(f, k) { return (ENGLISH_L[f] && ENGLISH_L[f][k]) || titleCase(k); }
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var WDL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var WDI = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function nice(d) {
    if (!/^en(?:-|$)/i.test(locale)) { try { return new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' }).format(d); } catch (e) {} }
    return WD[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()];
  }
  function titleDate(value) {
    if (/^en(?:-|$)/i.test(locale)) return value;
    var match = /(\d{1,2}) ([A-Za-z]+) (20\d{2})$/.exec(value), month = match ? MON.indexOf(match[2].slice(0, 3)) : -1;
    if (!match || month < 0) return value;
    var parsed = new Date(+match[3], month, +match[1], 12);
    return nice(parsed) + ' ' + parsed.getFullYear();
  }
  function hr12(h) { return (h % 12 || 12) + (h < 12 ? ' AM' : ' PM'); }
  /* India Standard Time wall clock, whatever the visitor's own time zone */
  function istNow() { var d = new Date(); return new Date(d.getTime() + (330 + d.getTimezoneOffset()) * 60000); }
  function parseYmd(s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || ''); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }

  /* Next group puja for a listing: weekly deity day (plus festival days for that deity), Amavasya, Ekadashi,
     a fixed date (YYYY-MM-DD) or none ("monthly" / blank). Names close at cutoff_hour IST the day before. */
  function nextGroup(gday, deity, CAL, now) {
    CAL = CAL || {}; now = now || istNow();
    if (!gday || gday === 'monthly') return null;
    var cut = typeof CAL.cutoff_hour === 'number' ? CAL.cutoff_hour : 18;
    var closed = CAL.closed || [];
    var weekly = Object.prototype.hasOwnProperty.call(WDI, gday);
    var fixed = /^\d{4}-\d{2}-\d{2}$/.test(gday);
    var list = gday === 'amavasya' ? (CAL.amavasya || []) : (gday === 'ekadashi' ? (CAL.ekadashi || []) : null);
    if (!weekly && !fixed && !list) return null;
    var fest = weekly ? (CAL.festivals || []).filter(function (f) { return (f.deities || []).indexOf(deity) > -1; }) : [];
    for (var i = 0; i < 400; i++) {
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      var close = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1, cut, 0, 0);
      if (now >= close) continue;
      var key = ymd(d);
      if (closed.indexOf(key) > -1) continue;
      if (fixed) { if (key === gday) return { d: d, label: null, close: close, cut: cut }; if (key > gday) return null; continue; }
      if (list) { if (list.indexOf(key) > -1) return { d: d, label: gday === 'amavasya' ? 'Amavasya' : 'Ekadashi', close: close, cut: cut }; continue; }
      for (var j = 0; j < fest.length; j++) { if (key >= fest[j].start && key <= fest[j].end) return { d: d, label: fest[j].label, close: close, cut: cut }; }
      if (WDI[gday] === d.getDay()) return { d: d, label: null, close: close, cut: cut };
    }
    return null;
  }
  function groupWhen(gday) {
    if (!gday) return '';
    if (Object.prototype.hasOwnProperty.call(WDI, gday)) return tr('every ' + WDL[WDI[gday]]);
    if (gday === 'amavasya') return tr('on every Amavasya');
    if (gday === 'ekadashi') return tr('on every Ekadashi');
    if (gday === 'monthly') return tr('once a month');
    var d = parseYmd(gday); return d ? tr('on {date}', { date: nice(d) + ' ' + d.getFullYear() }) : '';
  }

  /* What a listing offers: both (personal + group tiers), group, personal, seva, or pkg (old person-based packages) */
  function kindOf(x) {
    if (x.gn > 0 && x.pp > 0) return 'both';
    if (x.gn > 0 || x.m === 'group') return 'group';
    if (x.m === 'offering') return 'seva';
    if (x.m === 'confirm') return 'pkg';
    if (x.ts === 'ayodhya-booking' && x.m === 'both') return 'pkg';
    return 'personal';
  }
  function typesOf(x) { var k = x._k; return k === 'both' ? ['group', 'personal'] : k === 'group' ? ['group'] : k === 'seva' ? ['seva'] : k === 'personal' ? ['personal'] : []; }
  function bucket(lo) { var r = lo / 100; return r < 1000 ? '0-1000' : r < 2500 ? '1000-2500' : r < 5000 ? '2500-5000' : r < 10000 ? '5000-10000' : '10000-'; }
  function vals(x, f) {
    switch (f) {
      case 'type': return typesOf(x);
      case 'deity': return x.de ? [x.de] : [];
      case 'need': return x.n || [];
      case 'occasion': return (x.oc || []).filter(function (k) { return L.occasion[k]; });
      case 'ritual': return x.r ? [x.r] : [];
      case 'state': return x.st ? [x.st] : [];
      case 'price': return [bucket(x.lo)];
    }
    return [];
  }
  var searchSeparators;
  try { searchSeparators = new RegExp('[^\\p{L}\\p{M}\\p{N}]+', 'gu'); } catch (e) { searchSeparators = /[^a-z0-9\u0900-\u097f\u0980-\u09ff\u0b80-\u0bff\u0c00-\u0c7f\u0c80-\u0cff]+/g; }
  function norm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '').normalize('NFC');
    s = s.replace(/[\u200c\u200d]/g, '');
    return (' ' + s.replace(searchSeparators, ' ') + ' ')
      .replace(/ (ಪೂಜೆ|ಪೂಜಾ|ಪೂಜೆಗಳು|பூஜை|பூஜைகள்|पूजा|पूजाएँ|పూజ|పూజలు|পূজা) /g, ' puja ')
      .replace(/ poojan /g, ' pujan ').replace(/ pooja /g, ' puja ').replace(/ poojas /g, ' puja ').replace(/ pujas /g, ' puja ')
      .replace(/ rudra abhishek /g, ' rudrabhishek ').replace(/ rudrabhishekam /g, ' rudrabhishek ')
      .replace(/ navgrah /g, ' navgraha ').replace(/ navagraha /g, ' navgraha ')
      .replace(/ mrityunjay /g, ' mrityunjaya ').replace(/ mahamrityunjay[a]? /g, ' maha mrityunjaya ')
      .replace(/ shraddh /g, ' shraddha ').replace(/ shradh /g, ' shraddha ').replace(/ shradha /g, ' shraddha ')
      .replace(/ kal sarp /g, ' kaal sarp ').replace(/ kalsarp /g, ' kaal sarp ').replace(/ kaalsarp /g, ' kaal sarp ')
      .replace(/ shiva /g, ' shiv ').replace(/ shankar /g, ' shiv ').replace(/ mahadev /g, ' shiv ')
      .replace(/ ganesha /g, ' ganesh ').replace(/ ganpati /g, ' ganesh ').replace(/ ganapati /g, ' ganesh ')
      .replace(/ hanumanji /g, ' hanuman ').replace(/ bajrangbali /g, ' hanuman ')
      .replace(/ banaras /g, ' varanasi ').replace(/ benares /g, ' varanasi ').replace(/ kashi /g, ' varanasi ')
      .replace(/ allahabad /g, ' prayagraj ').replace(/ homam /g, ' havan ').replace(/ homa /g, ' havan ').replace(/ hawan /g, ' havan ')
      .replace(/\s+/g, ' ');
  }
  function hay(x) {
    if (x._h) return x._h;
    var parts = [x.t, englishLabel('deity', x.de), englishLabel('ritual', x.r), label('deity', x.de), label('ritual', x.r), x.st ? titleCase(x.st) : '', x.pl ? titleCase(x.pl) : ''];
    typesOf(x).forEach(function (k) { parts.push(englishLabel('type', k), label('type', k)); });
    if (x.st) parts.push(tr(titleCase(x.st)));
    if (x.pl && DISPLAY.places && DISPLAY.places[x.pl]) parts.push(DISPLAY.places[x.pl]);
    (x.n || []).forEach(function (k) { parts.push(englishLabel('need', k), label('need', k)); });
    (x.oc || []).forEach(function (k) { if (L.occasion[k]) parts.push(ENGLISH_L.occasion[k], L.occasion[k]); });
    (x.sp || []).forEach(function (k) { parts.push(titleCase(k), tr(titleCase(k))); });
    x._h = norm(parts.join(' '));
    return x._h;
  }
  function splitTitle(x) {
    var t = x.t || '', i = t.indexOf(' — ');
    var name = i > -1 ? t.slice(0, i) : t, place = i > -1 ? t.slice(i + 3) : '';
    if (/private puja/i.test(place) || /\b20\d\d\b/.test(place)) place = x.pl ? titleCase(x.pl) : '';
    name = name.replace(/,? — ?Private Puja$/i, '');
    return [name, place];
  }

  function cardHtml(x, CAL, NOW) {
    var k = x._k, tp = splitTitle(x), when = '', price = '', tags = '';
    var dm = /\b(Mon|Tue|Wed|Thu|Fri|Sat|Sun) \d{1,2} (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) 20\d\d\b/.exec(x.t || '') ||
      /\b\d{1,2} (January|February|March|April|May|June|July|August|September|October|November|December) 20\d\d\b/.exec(x.t || '');
    if (k === 'both' || k === 'group') {
      if (x._ng === undefined) x._ng = nextGroup(x.d, x.de, CAL, NOW);
      if (x._ng) when = tr('Next group puja: {date}', { date: nice(x._ng.d) }) + (x._ng.label ? ' · ' + tr(x._ng.label) : '');
      else if (dm) when = tr('On {date}', { date: titleDate(dm[0]) });
      else if (groupWhen(x.d)) when = tr('Group puja {when}', { when: groupWhen(x.d) });
      if (k === 'group' && /^\d{4}-\d{2}-\d{2}$/.test(x.d || '') && !x._ng) when = tr('Bookings for this date have closed');
    } else if (dm) when = tr('On {date}', { date: titleDate(dm[0]) });
    else if (k === 'seva') when = tr('Offered in your name');
    /* No "confirm", "checkout" or "place order" in card text: the GoKwik script treats any link or button
       containing those words as a checkout button and would open checkout instead of the puja page. */
    else when = tr('Date set on WhatsApp');
    if (k === 'both') {
      tags = '<span class="dpc__tag dpc__tag--g">'+ esc(tr('Group')) +'</span><span class="dpc__tag dpc__tag--p">'+ esc(tr('Personal')) +'</span>';
      price = '<b>' + money(x.pp) + '</b> <small>'+ esc(tr('personal')) +'</small><em>'+ esc(tr('Group from')) +' ' + money(x.gm) + '</em>';
    } else if (k === 'group') {
      tags = '<span class="dpc__tag dpc__tag--g">'+ esc(tr('Group puja')) +'</span>';
      price = (x.gn > 1 ? '<small>'+ esc(tr('From')) +'</small> ' : '') + '<b>' + money(x.gm || x.lo) + '</b>';
    } else if (k === 'seva') {
      tags = '<span class="dpc__tag dpc__tag--s">'+ esc(tr('Seva')) +'</span>';
      price = '<b>' + money(x.lo) + '</b>';
    } else if (k === 'pkg') {
      price = (x.pk > 1 && x.px > x.pp ? '<small>'+ esc(tr('From')) +'</small> ' : '') + '<b>' + money(x.lo) + '</b>';
    } else {
      tags = '<span class="dpc__tag dpc__tag--p">'+ esc(tr('Personal puja')) +'</span>';
      price = (x.pk > 1 && x.px > x.pp ? '<small>'+ esc(tr('From')) +'</small> ' : '') + '<b>' + money(x.pp || x.lo) + '</b>';
    }
    return '<a class="dpc" href="' + esc(localUrl(x.u)) + '">' +
      '<span class="dpc__img">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" decoding="async" width="360" height="360">' : '<span class="dpc__ph" aria-hidden="true">🕉</span>') + '</span>' +
      '<span class="dpc__body">' + (tags ? '<span class="dpc__tags">' + tags + '</span>' : '') +
      '<h3 class="dpc__title">' + esc(tp[0]) + '</h3>' +
      (tp[1] ? '<span class="dpc__place">' + esc(tp[1]) + '</span>' : '') +
      (when ? '<span class="dpc__when">' + esc(when) + '</span>' : '') +
      '<span class="dpc__price">' + price + '</span></span></a>';
  }

  /* A theme preview is kept in the session cookie after the first page view, so the data URL needs no
     preview_theme_id (adding it makes Shopify redirect and drop the view parameter). */
  var dataCache = {};
  function loadFeed(base) {
    if (dataCache[base]) return dataCache[base];
    function url(page) { return base + (base.indexOf('?') > -1 ? '&' : '?') + 'view=puja-data&page=' + page; }
    function get(page) {
      /* plain request: with "Accept: application/json" Shopify answers with its own collection JSON instead of this view */
      return fetch(url(page), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    dataCache[base] = get(1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(get(p));
      return Promise.all(rest).then(function (more) {
        var items = first.items || [];
        more.forEach(function (m) { items = items.concat(m.items || []); });
        return { meta: first, items: items };
      });
    });
    return dataCache[base];
  }

  var listeners = [], instances = [];

  /* ---------- catalogue instance ---------- */
  function Catalogue(root) {
    this.root = root;
    this.base = root.getAttribute('data-feed') || '/collections/all-pujas';
    this.hide = (root.getAttribute('data-hide') || '').split(',').filter(Boolean);
    this.noun = root.getAttribute('data-noun') || tr('pujas');
    var calEl = root.querySelector('[data-dhc-cal]');
    try { this.CAL = calEl ? JSON.parse(calEl.textContent || '{}') || {} : {}; } catch (e) { this.CAL = {}; }
    this.NOW = istNow();
    this.items = [];
    this.st = { q: '', sort: 'rec', shown: PAGE, sel: {} };
    var self = this;
    FACETS.forEach(function (f) { self.st.sel[f] = {}; });
    this.$ = function (s) { return root.querySelector(s); };
    this.readUrl();
    this.bind();
    this.load();
    instances.push(this);
  }
  Catalogue.prototype.readUrl = function () {
    var sp = new URLSearchParams(window.location.search), st = this.st;
    st.q = sp.get('q') || '';
    st.sort = sp.get('sort') || 'rec';
    FACETS.forEach(function (f) { (sp.get(f) || '').split(',').filter(Boolean).forEach(function (v) { st.sel[f][v] = true; }); });
    var qi = this.$('[data-dhc-q]'); if (qi) qi.value = st.q;
    var so = this.$('[data-dhc-sort]'); if (so) so.value = st.sort;
  };
  Catalogue.prototype.writeUrl = function () {
    if (!window.history || !history.replaceState) return;
    var sp = new URLSearchParams(window.location.search), st = this.st;
    if (st.q) sp.set('q', st.q); else sp['delete']('q');
    if (st.sort && st.sort !== 'rec') sp.set('sort', st.sort); else sp['delete']('sort');
    FACETS.forEach(function (f) { var v = Object.keys(st.sel[f]); if (v.length) sp.set(f, v.join(',')); else sp['delete'](f); });
    sp['delete']('page');
    var qs = sp.toString();
    history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  };
  Catalogue.prototype.bind = function () {
    var self = this, root = this.root, t = null;
    var qi = this.$('[data-dhc-q]');
    if (qi) qi.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { self.st.q = qi.value.trim(); self.st.shown = PAGE; self.render(); }, 160); });
    var form = this.$('[data-dhc-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (qi) { self.st.q = qi.value.trim(); self.st.shown = PAGE; self.render(); qi.blur(); } });
    var so = this.$('[data-dhc-sort]');
    if (so) so.addEventListener('change', function () { self.st.sort = so.value; self.st.shown = PAGE; self.render(); });
    root.addEventListener('change', function (e) {
      var cb = e.target.closest && e.target.closest('[data-dhc-f]'); if (!cb) return;
      var f = cb.getAttribute('data-dhc-f'), v = cb.value;
      if (cb.checked) self.st.sel[f][v] = true; else delete self.st.sel[f][v];
      self.st.shown = PAGE; self.render();
    });
    root.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target : null; if (!el) return;
      var chip = el.closest('[data-dhc-chip]');
      if (chip) {
        var f = chip.getAttribute('data-dhc-chip'), v = chip.getAttribute('data-v');
        self.st.sel[f] = {}; if (v) self.st.sel[f][v] = true;
        self.st.shown = PAGE; self.render(); return;
      }
      var rm = el.closest('[data-dhc-rm]');
      if (rm) { delete self.st.sel[rm.getAttribute('data-dhc-rm')][rm.getAttribute('data-v')]; self.st.shown = PAGE; self.render(); return; }
      if (el.closest('[data-dhc-clear]')) { self.clear(); return; }
      if (el.closest('[data-dhc-more]')) { self.st.shown += PAGE; self.render(true); return; }
      if (el.closest('[data-dhc-open]')) { self.sheet(true); return; }
      if (el.closest('[data-dhc-close]') || el.closest('[data-dhc-apply]')) { self.sheet(false); return; }
      var all = el.closest('[data-dhc-all]');
      if (all) { var box = all.parentNode; box.classList.toggle('is-all'); all.textContent = box.classList.contains('is-all') ? tr('Show fewer') : all.getAttribute('data-lbl'); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-sheet')) self.sheet(false); });
  };
  Catalogue.prototype.sheet = function (open) {
    this.root.classList.toggle('is-sheet', !!open);
    document.documentElement.classList.toggle('dhc-lock', !!open);
    if (open) { var c = this.$('[data-dhc-close]'); if (c) c.focus(); }
  };
  Catalogue.prototype.clear = function () {
    var st = this.st; st.q = ''; FACETS.forEach(function (f) { st.sel[f] = {}; });
    var qi = this.$('[data-dhc-q]'); if (qi) qi.value = '';
    st.shown = PAGE; this.render();
  };
  Catalogue.prototype.setQuery = function (q) {
    this.st.q = q || ''; var qi = this.$('[data-dhc-q]'); if (qi) qi.value = this.st.q;
    this.st.shown = PAGE; if (this.items.length) this.render();
  };
  Catalogue.prototype.load = function () {
    var self = this;
    loadFeed(this.base).then(function (data) {
      var CAL = self.CAL, NOW = self.NOW;
      self.items = (data.items || []).filter(function (x) { return x && x.a && x.de; }); /* x.de: only puja listings (add-ons in a puja collection carry no puja:deity tag) */
      self.items.forEach(function (x, i) { x._i = i; x._k = kindOf(x); });
      self.root.classList.add('is-live');
      var pager = self.$('[data-dhc-pager]'); if (pager) pager.hidden = true;
      self.render();
      listeners.forEach(function (cb) { try { cb(self.items, CAL, NOW, self); } catch (e) {} });
    })['catch'](function () { self.root.classList.add('is-static'); });
  };
  Catalogue.prototype.match = function (x, skip) {
    var st = this.st;
    for (var i = 0; i < FACETS.length; i++) {
      var f = FACETS[i]; if (f === skip) continue;
      var sel = st.sel[f], keys = Object.keys(sel); if (!keys.length) continue;
      var v = vals(x, f), ok = false;
      for (var j = 0; j < v.length; j++) { if (sel[v[j]]) { ok = true; break; } }
      if (!ok) return false;
    }
    return true;
  };
  Catalogue.prototype.searchOk = function (x, toks) {
    if (!toks.length) return true;
    var h = hay(x), hz = h.replace(/ /g, '');
    for (var i = 0; i < toks.length; i++) { if (h.indexOf(' ' + toks[i]) === -1 && hz.indexOf(toks[i]) === -1) return false; }
    return true;
  };
  Catalogue.prototype.render = function (append) {
    var self = this, st = this.st, CAL = this.CAL, NOW = this.NOW;
    var toks = norm(st.q).trim().split(' ').filter(function (w) { return w && w.length > 1 && ['puja', 'the', 'and', 'for', 'in', 'at', 'of', 'ki', 'ka', 'ke'].indexOf(w) === -1; });
    var base = this.items.filter(function (x) { return self.searchOk(x, toks); });
    var list = base.filter(function (x) { return self.match(x); });
    if (st.sort === 'price-asc') list.sort(function (a, b) { return a.lo - b.lo || a._i - b._i; });
    else if (st.sort === 'price-desc') list.sort(function (a, b) { return b.lo - a.lo || a._i - b._i; });
    else if (st.sort === 'name') list.sort(function (a, b) { return a.t.localeCompare(b.t); });
    else if (st.sort === 'next') list.sort(function (a, b) {
      function key(x) { if (x._k !== 'both' && x._k !== 'group') return 9e15; if (x._ng === undefined) x._ng = nextGroup(x.d, x.de, CAL, NOW); return x._ng ? x._ng.d.getTime() : 8e15; }
      return key(a) - key(b) || a._i - b._i;
    });
    else list.sort(function (a, b) { return a._i - b._i; });
    this.list = list;

    var grid = this.$('[data-dhc-grid]');
    if (grid) {
      var from = append ? Math.max(0, st.shown - PAGE) : 0;
      var html = list.slice(from, st.shown).map(function (x) { return cardHtml(x, CAL, NOW); }).join('');
      if (append) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
    }
    var more = this.$('[data-dhc-more]');
    if (more) { var left = list.length - st.shown; more.hidden = left <= 0; more.textContent = tr('Show more {noun} ({count})', { noun: this.noun, count: Math.max(0, left) }); }
    var empty = this.$('[data-dhc-empty]'); if (empty) empty.hidden = list.length > 0;
    var cnt = this.$('[data-dhc-count]');
    if (cnt) cnt.textContent = list.length === this.items.length ? tr('{count} {noun}', { count: list.length, noun: this.noun }) : tr('{count} of {total} {noun}', { count: list.length, total: this.items.length, noun: this.noun });
    var apply = this.$('[data-dhc-apply]'); if (apply) apply.textContent = tr('Show {count} {noun}', { count: list.length, noun: this.noun });
    if (!append) { this.renderFacets(base); this.renderActive(); }
    this.writeUrl();
  };
  Catalogue.prototype.renderFacets = function (base) {
    var self = this, st = this.st, box = this.$('[data-dhc-facets]'), chipsBox = this.$('[data-dhc-chips]');
    var counts = {};
    FACETS.forEach(function (f) {
      var c = {};
      base.forEach(function (x) { if (!self.match(x, f)) return; vals(x, f).forEach(function (v) { c[v] = (c[v] || 0) + 1; }); });
      Object.keys(st.sel[f]).forEach(function (v) { if (!c[v]) c[v] = 0; });
      counts[f] = c;
    });
    /* universe per facet (all values present in this collection), to decide which facets to show */
    if (!this.universe) {
      var u = {}; FACETS.forEach(function (f) { u[f] = {}; self.items.forEach(function (x) { vals(x, f).forEach(function (v) { u[f][v] = 1; }); }); });
      this.universe = u;
    }
    var shown = FACETS.filter(function (f) { return self.hide.indexOf(f) === -1 && Object.keys(self.universe[f]).length > 1; });
    if (box) {
      box.innerHTML = shown.map(function (f) {
        var c = counts[f], keys = Object.keys(self.universe[f]);
        if (FIXED_ORDER[f]) keys = FIXED_ORDER[f].filter(function (k) { return self.universe[f][k]; });
        else keys.sort(function (a, b) { return (c[b] || 0) - (c[a] || 0) || label(f, a).localeCompare(label(f, b)); });
        var nsel = Object.keys(st.sel[f]).length, long = keys.length > 8;
        var rows = keys.map(function (k, i) {
          var n = c[k] || 0, on = !!st.sel[f][k];
          return '<label class="dhc__opt' + (n === 0 && !on ? ' is-zero' : '') + (long && i >= 6 && !on ? ' is-extra' : '') + '"><input type="checkbox" data-dhc-f="' + f + '" value="' + esc(k) + '"' + (on ? ' checked' : '') + '><span>' + esc(label(f, k)) + '</span><small>' + n + '</small></label>';
        }).join('');
        var openAttr = (f === 'type' || f === 'deity' || nsel) ? ' open' : '';
        return '<details class="dhc__fg"' + openAttr + '><summary>' + esc(tr(FTITLE[f])) + (nsel ? ' <b>' + nsel + '</b>' : '') + '</summary><div class="dhc__opts">' + rows +
          (long ? '<button type="button" class="dhc__all" data-dhc-all data-lbl="' + esc(tr('Show all {count}', { count: keys.length })) + '">' + esc(tr('Show all {count}', { count: keys.length })) + '</button>' : '') + '</div></details>';
      }).join('');
    }
    var fc = this.$('[data-dhc-fcount]');
    var total = 0; FACETS.forEach(function (f) { total += Object.keys(st.sel[f]).length; });
    if (fc) { fc.textContent = total; fc.hidden = !total; }
    /* quick chips: the first visible facet among deity / need / ritual */
    if (chipsBox) {
      var qf = ['deity', 'need', 'ritual'].filter(function (f) { return shown.indexOf(f) > -1; })[0];
      if (!qf) { chipsBox.innerHTML = ''; chipsBox.hidden = true; return; }
      var c = counts[qf], keys = Object.keys(self.universe[qf]).sort(function (a, b) { return (c[b] || 0) - (c[a] || 0); });
      var selKeys = Object.keys(st.sel[qf]);
      var html = '<button type="button" class="dhc__chip' + (selKeys.length ? '' : ' is-on') + '" data-dhc-chip="' + qf + '" data-v="" aria-pressed="' + (selKeys.length ? 'false' : 'true') + '">' + esc(tr('All')) + '</button>';
      html += keys.map(function (k) {
        var on = selKeys.length === 1 && st.sel[qf][k];
        return '<button type="button" class="dhc__chip' + (on ? ' is-on' : '') + '" data-dhc-chip="' + qf + '" data-v="' + esc(k) + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (!(c[k] || 0) && !on ? ' disabled' : '') + '>' + esc(label(qf, k)) + ' <small>' + (c[k] || 0) + '</small></button>';
      }).join('');
      chipsBox.innerHTML = html; chipsBox.hidden = false;
    }
  };
  Catalogue.prototype.renderActive = function () {
    var st = this.st, box = this.$('[data-dhc-active]'); if (!box) return;
    var chips = [];
    FACETS.forEach(function (f) { Object.keys(st.sel[f]).forEach(function (v) { chips.push('<button type="button" class="dhc__act" data-dhc-rm="' + f + '" data-v="' + esc(v) + '" aria-label="' + esc(tr('Remove {label}', { label: label(f, v) })) + '">' + esc(label(f, v)) + ' <span aria-hidden="true">✕</span></button>'); }); });
    if (st.q) chips.unshift('<span class="dhc__act dhc__act--q">“' + esc(st.q) + '”</span>');
    box.innerHTML = chips.length ? chips.join('') + '<button type="button" class="dhc__clear" data-dhc-clear>' + esc(tr('Clear all')) + '</button>' : '';
    box.hidden = !chips.length;
  };

  function init() {
    [].forEach.call(document.querySelectorAll('[data-dhc]'), function (el) { if (!el.__dhc) { el.__dhc = new Catalogue(el); } });
  }
  window.DHPuja = window.DHPuja || {};
  window.DHPuja.__catalogue = true;
  window.DHPuja.nextGroup = nextGroup;
  window.DHPuja.groupWhen = groupWhen;
  window.DHPuja.kindOf = kindOf;
  window.DHPuja.money = money;
  window.DHPuja.nice = nice;
  window.DHPuja.hr12 = hr12;
  window.DHPuja.istNow = istNow;
  window.DHPuja.labels = L;
  window.DHPuja.instances = instances;
  window.DHPuja.onData = function (cb) { listeners.push(cb); instances.forEach(function (c) { if (c.items.length) { try { cb(c.items, c.CAL, c.NOW, c); } catch (e) {} } }); };
  window.DHPuja.search = function (q) { instances.forEach(function (c) { c.setQuery(q); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
